import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
//@ts-ignore
import { useForm } from "react-hook-form";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useQueryClient } from "@tanstack/react-query";
import { CrossIcon } from "lucide-react";
import { useState } from "react";
import APIS from "../../../constant/Endpoint";
import useGetHook from "../../../customHooks/useGetHook";
import usePostHook from "../../../customHooks/usePostHook";
import Button from "../Button";
import RecursiveComment from "./RecursiveComment";
import { remarksValidation } from "../../../utils/validationSchema";

const Remark = (props: any) => {
  const { refetchQueries } = useQueryClient();
  const [comment, setComment] = useState<any>();

  const { data: profile } = useGetHook({
    queryKey: [`profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });

  const { data: remarks } = useGetHook({
    queryKey: [`remarks-${props?.selected}`],
    url: APIS.COMMENT,
    params: {
      limit: 200,
      offset: 0,
      object_id: props?.selected,
    },
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: [`remarks-${props?.selected}`],
    navigateURL: "",
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
  } = useForm<any>({
    resolver: yupResolver(remarksValidation),
  });

  const handleCreateReview = async (data: any, id: any) => {
    const url = `${APIS.COMMENT}`;
    let formData = {
      ...data,
      branch: profile?.default_branch?.id,
      parent: id,
      object_id: props?.selected,
    };
    try {
      await mutateAsync({ url, formData, setError });
      reset();
      setComment(null);
      refetchQueries();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <section className={tw`bg-white  mt-4`}>
        <div className={tw`mx-auto px-4`}>
          <div className={tw`flex justify-center uppercase`}>
            {props?.receiver || "Remarks"}
          </div>
          <div className={tw`max-h-[50svh] overflow-y-auto`}>
            {remarks?.results?.map((item, index) => (
              <RecursiveComment
                key={item?.id}
                item={item}
                setComment={setComment}
              />
            ))}
          </div>
          <div className={tw`mt-4 `}>
            <form className={tw`mb-6`}>
              {comment && (
                <div className={tw`my-1 border-t-[1px]`}>
                  <div className="flex justify-between w-full items-center">
                    <p className={tw`text-base`}>
                      Replying to {comment?.user?.name}
                    </p>
                    <button
                      className={tw`cursor-pointer`}
                      onClick={() => setComment("")}
                    >
                      <CrossIcon />
                    </button>
                  </div>

                  <p className={tw`text-gray-500 ml-2`}>{comment?.comment}</p>
                </div>
              )}
              <div
                className={tw`py-2 px-4 mb-4 bg-white rounded-lg rounded-t-lg border border-gray-200 `}
              >
                <textarea
                  id="comment"
                  rows={6}
                  {...register("comment")}
                  className={tw`px-0 w-full text-sm bg-white text-gray-900 border-0 focus:ring-0 focus:outline-none `}
                  placeholder="Write a comment..."
                  required
                ></textarea>

                {errors.comment && (
                  <p className={tw`text-red-500 text-xs my-1`}>
                    {errors?.comment?.message as string}
                  </p>
                )}
              </div>
              <div className={tw`flex justify-end w-full`}>
                <div className={tw`w-[100px] mr-4`}>
                  <Button
                    label={"Create"}
                    isLoading={isPostLoading}
                    onClick={handleSubmit((data: any) =>
                      handleCreateReview(data, comment?.id)
                    )}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default Remark;
